import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class UserDynamicFeatureCriteria extends BasicCriteria {
mail: string;
userLoginLike: string;
}

